import { RouterProvider, createBrowserRouter } from "react-router-dom";
import ErrorPage from "./components/error/ErrorPage";
import RootLayout from "./components/root/RootLayout";
import LoggedOutOnly from "./components/helpers/LoggedOutOnly";
import LoggedInOnly from "./components/helpers/LoggedInOnly";
import { useEffect, useState } from "react";
import LoginPage from "./components/login/LoginPage";
import LogoutPage from "./components/logout/LogoutPage";
import Chats from "./components/chats/Chats";
import { Outlet } from "react-router-dom";
import Messages from "./components/chats/Messages";
import Users from "./components/chats/Users";
import IndexPage from "./components/Index";

const getInitialUser = () => {
  // Getting logged user from localStorage
  const savedUser = localStorage.getItem("messageUser")
    ? JSON.parse(localStorage.getItem("messageUser"))
    : undefined;

  if (
    !savedUser ||
    !savedUser.id ||
    !savedUser.username ||
    !savedUser.token ||
    !savedUser.expireAt ||
    !savedUser.permissions
  )
    return null;

  const time = new Date().getTime();
  if (time > savedUser.expireAt) return null;

  return savedUser;
};

function App() {
  const [user, setUser] = useState(getInitialUser());

  useEffect(() => {
    localStorage.setItem("messageUser", JSON.stringify(user));
    if (user) {
      const time = new Date().getTime();
      const logoutTimeout = setTimeout(() => {
        setUser(null);
      }, user.expireAt - time);
      return () => clearTimeout(logoutTimeout);
    }
  }, [user]);

  return (
    <RouterProvider
      router={createBrowserRouter([
        {
          path: "/",
          element: <RootLayout user={user} />,
          errorElement: <ErrorPage />,
          children: [
            {
              index: true,
              element: <IndexPage />,
            },
            {
              path: "login",
              element: (
                <LoggedOutOnly user={user}>
                  <LoginPage setUser={setUser} />
                </LoggedOutOnly>
              ),
            },
            {
              path: "logout",
              element: (
                <LoggedInOnly user={user}>
                  <LogoutPage setUser={setUser} />
                </LoggedInOnly>
              ),
            },
            {
              path: "chats",
              element: (
                <LoggedInOnly user={user}>
                  <Outlet />
                </LoggedInOnly>
              ),
              children: [
                { index: true, element: <Chats user={user} /> },
                {
                  path: "users",
                  element: <Users user={user} />,
                },
                {
                  path: ":chatId",
                  element: <Messages user={user} />,
                },
              ],
            },
          ],
        },
      ])}
    />
  );
}

export default App;
